import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileArrowLeftOut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFileArrowLeftOut"><Path d="M14.5 21.5H19.5V9L13 2.5H4.5V13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13 3V9H19" stroke="currentColor" strokeLinecap="round"/><Path d="M4.5 19.5H11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 16.5L3.5 19.5L6.5 22.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFileArrowLeftOut;
